export default __webpack_public_path__ + "static/media/logo_gumbo_mambo_-_logo_website_-_final.d8105771.png";